import * as React from "react";
import { MarketTemplate } from "../../../../../data";
import { prepareEmptyMarket } from "../../../../../helpers";
import { renderOutrightBetButtons } from "./renderOutrightBetButtons";
import { toJS } from "mobx";
export const renderOutrightMarkets = (cardProps, buttonsHolderClass, componentPrefix) => {
    const market = cardProps.markets.length > 0
        ? cardProps.markets[0]
        : prepareEmptyMarket(cardProps.event.id, MarketTemplate.ThreeBox, 0);
    const marketJS = toJS(market);
    marketJS.template = MarketTemplate.ThreeBox;
    return (React.createElement("div", { key: `${componentPrefix}__buttons-holder__${cardProps.event.id}`, className: `rj-ev-list__${componentPrefix}__buttons-holder ${buttonsHolderClass}`, "data-uat": `div-ev-list-${componentPrefix}-buttons-holder` }, renderOutrightBetButtons(marketJS, cardProps.handlers.betButton, componentPrefix, cardProps.hideLowOdds, cardProps.event)));
};
//# sourceMappingURL=renderOutrightMarkets.js.map